// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1rM6P","label":"Radio_label__CECb4","checkMark":"Radio_checkMark__2ZrmR","disabled":"Radio_disabled__14UwY"};